// @core/api/endpoints/form/export_form_submissions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportFormSubmissionsResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Export form submissions
 * Exports all submissions for a form in the specified format (CSV, JSON, XLSX).
 */
export async function ExportFormSubmissions(
  form_id: string,
  params?: {
    format?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ExportFormSubmissionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/submissions/export`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.get<ExportFormSubmissionsResponse>(requestPath, { ...requestOptions, params });
}
